import React from "react";
import Auth from "@aws-amplify/auth";
import {
  CognitoHostedUIIdentityProvider,
  FederatedSignInOptions,
} from "@aws-amplify/auth/lib-esm/types";
import { Image } from "react-native";
import { Button } from "react-native-elements";
import { useRecoilCallback } from "recoil";
import { selfGuidedTourSelectedState } from "../client";
import { colors, UNIT } from "../styles";

export const LoginButtons: React.FC = () => {
  const onLogIn = useRecoilCallback(
    ({ set }) => (options?: FederatedSignInOptions) => {
      set(selfGuidedTourSelectedState, false);
      Auth.federatedSignIn(options);
    }
  );

  return (
    <>
      <Button
        title="Sign in with Google"
        icon={
          <Image
            style={{ width: 32, height: 32, marginRight: UNIT }}
            source={require("../../assets/img/social/google/btn_google_light_normal_ios@3x.png")}
          />
        }
        onPress={() =>
          onLogIn({ provider: CognitoHostedUIIdentityProvider.Google })
        }
        style={{ width: "80%", margin: "auto", marginBottom: UNIT }}
        type="outline"
        titleStyle={{
          color: "white",
        }}
        buttonStyle={{
          height: UNIT * 4,
          backgroundColor: "#4285F4",
        }}
      />
      <Button
        title="Sign in with email"
        onPress={() => onLogIn()}
        style={{ width: "80%", margin: "auto" }}
        type="outline"
        titleStyle={{
          color: colors.green,
        }}
        buttonStyle={{
          height: UNIT * 4,
          backgroundColor: "white",
          borderColor: colors.green,
        }}
      />
    </>
  );
};
